import { isNil, pickBy } from 'ramda';

import { mapJsonQuery } from './jsonQuery';
import { ISearchPromosResponse } from '../repositories/newbuilding-promos/v1/search-promos';
import { IFilterSelector } from '../types/filterSelectors';
import { IJsonQuery } from '../types/jsonQuery/jsonQuery';
import { containsJsonQuery } from '../utils/jsonQuery/containsJsonQuery';

export const mapFilterSelectors = (promosResponse: ISearchPromosResponse): IFilterSelector[] => {
  const jsonQuery: IJsonQuery = mapJsonQuery(promosResponse.jsonQuery);

  return promosResponse.filterSelectors.map(selector => {
    const chipJsonQuery: IJsonQuery = pickBy(item => !isNil(item), mapJsonQuery(selector.jsonQuery));

    const isActive = containsJsonQuery(jsonQuery, chipJsonQuery);

    return {
      jsonQuery: chipJsonQuery,
      isActive,
      name: selector.name,
    };
  });
};
